import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Globals } from 'app/services/globals'
import * as txml from 'txml';
import { unescapeHtml } from 'app/helpers/utils';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class WopiService {
    private cachedWopiDiscovery: any = null;

    constructor(private http: HttpClient, private globals: Globals, private userService: UserService) { 
        
    }

    getWopiConfig() {
        if (!this.cachedWopiDiscovery) {
            return this.http.get(this.globals.wopi_base_url + '/discovery?access_token=' + this.userService.access_token, {
                responseType: 'text'
            }).pipe(map((xmlText) => {
                let appsArray = txml.parse(xmlText, {
                    filter: (e) => { return e.tagName.toLowerCase() == 'app' &&
                                            (e.attributes['name'] == 'Excel' || e.attributes['name'] == 'Word' || e.attributes['name'] == 'PowerPoint'  || e.attributes['name'] == 'WopiTest')
                    }
                });
                this.cachedWopiDiscovery = {};
                appsArray.forEach((appTag: txml.tNode) => {
                    appTag.children.forEach((actionTag: txml.tNode) => {
                        if (actionTag.tagName == 'action') {
                            if (actionTag.attributes['ext']) {
                                if (!this.cachedWopiDiscovery[actionTag.attributes['ext']]) {
                                    this.cachedWopiDiscovery[actionTag.attributes['ext']] = {};
                                }
                                if (actionTag.attributes['name'] == 'open' || actionTag.attributes['name'] == 'view' || 
                                    actionTag.attributes['name'] == 'edit' || actionTag.attributes['name'] == 'convert') {
                                    this.cachedWopiDiscovery[actionTag.attributes['ext']][actionTag.attributes['name']] = {
                                        urlsrc: unescapeHtml(actionTag.attributes['urlsrc']),
                                        favIconUrl: unescapeHtml(appTag.attributes['favIconUrl']),
                                        appName: appTag.attributes['name']
                                    }
                                }
                            }
                        }
                    });
                });

                return this.cachedWopiDiscovery;
            }));
        } else {
            return of(this.cachedWopiDiscovery);
        }    
    }

    getFileWopiID(storageId: number, path: string, version_id: string = '', viewOnlyThisVersion: boolean = false) {
        return this.http.get<any>( `${this.globals.api_base_url}/storage/${storageId}/wopi_id?path=${encodeURIComponent(path)}&view_only_this_version=${viewOnlyThisVersion? 1:0}&version_id=${version_id}`).pipe((map(r => r.id as number)));
    }

    getFileInfo(wopiFileId: number) {
        return this.http.get<any>(`${this.globals.wopi_files_endpoint}/${wopiFileId}?access_token=${this.userService.access_token}`);
    }
}